import { useState, useEffect } from "react";
import { appendScripts } from "@nxplatform/ssr-service/helpers/append-scripts";
import { removeCustomerExpiredAuthToken } from "@nxplatform/store-utils/misc/utils";
import { getQueryParam, setCookieData } from "./affiliate.service.js";
import { fetchBaseWindowConfig } from "./base-window-setup.service.js";
const closeParentIframeLinks = ["casino/game/exit", "live-casino/game/exit", "game/exit"];
const liveCasinoPath = "/live-casino";
const casinoPth = "/casino";
const closeLiveChatConnection = (e) => {
  if (e.persisted) return;
  if (window.LiveChatWidget) {
    window.LiveChatWidget.call("destroy");
  }
};
const restoreLiveChatConnection = (e) => {
  window.persistedBfCache = e.persisted;
  if (!e.persisted) return;
  if (!window.LiveChatWidget && window.liveChatScript) {
    appendScripts(JSON.parse(window.liveChatScript));
  }
};
function isMobileUA() {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}
const useApplicationBootHook = (environment) => {
  window.disableRedirect = !!getQueryParam(window.location.search).get("disableRedirect");
  window.isMobile = isMobileUA() || !!getQueryParam(window.location.search).get("webView") || !!getQueryParam(window.location.search).get("imbaWebView");
  const [config, setConfig] = useState(null);
  const { pathname, search } = window.location;
  removeCustomerExpiredAuthToken();
  const gameExitCasino = (path) => {
    return !!closeParentIframeLinks.find((link) => path.endsWith(link));
  };
  useEffect(() => {
    window.addEventListener("pagehide", closeLiveChatConnection, { capture: true });
    window.addEventListener("pageshow", restoreLiveChatConnection, { capture: true });
    window.addEventListener("beforeunload", closeLiveChatConnection, { capture: true });
    return () => {
      window.removeEventListener("pagehide", closeLiveChatConnection, { capture: true });
      window.removeEventListener("pageshow", restoreLiveChatConnection, { capture: true });
      window.removeEventListener("beforeunload", closeLiveChatConnection, { capture: true });
    };
  }, []);
  useEffect(() => {
    if (gameExitCasino(pathname)) {
      const win = window.top !== window ? window.top : window.opener || window;
      if (pathname.includes("live")) {
        win.location.href = liveCasinoPath;
      }
      if (!pathname.includes("live")) {
        win.location.href = casinoPth;
      }
      if (window.opener) {
        window.close();
      }
    }
  }, [pathname]);
  useEffect(() => {
    const { pathname: pathname2, search: search2 } = window.location;
    const fetchConfig = async () => {
      const {
        status,
        loaded,
        payload,
        data
      } = await fetchBaseWindowConfig(
        pathname2,
        search2,
        environment,
        // @ts-ignore
        window.__APP_DATA__
      );
      setCookieData(search2);
      return {
        status,
        loaded,
        payload,
        data
      };
    };
    const setConfigData = () => {
      return fetchConfig().then(({
        status,
        loaded,
        payload,
        data
      }) => {
        setConfig({
          status,
          loaded,
          payload,
          data
        });
      }).catch(console.error);
    };
    const checkReady = () => {
      if (window.__APP_READY__) {
        return setConfigData();
      }
    };
    checkReady();
    if (window.__APP_DATA__) {
      if (window.__APP_READY__) {
        setConfigData();
      } else {
        window.addEventListener("appReady", checkReady);
      }
    }
    return () => {
      window.removeEventListener("appReady", checkReady);
    };
  }, []);
  useEffect(() => {
    if (!window.__APP_DATA__) {
      const fetchConfig = async () => {
        const {
          status,
          loaded,
          payload,
          data
        } = await fetchBaseWindowConfig(pathname, search, environment);
        setCookieData(search);
        return {
          status,
          loaded,
          payload,
          data
        };
      };
      fetchConfig().then(({
        status,
        loaded,
        payload,
        data
      }) => {
        setConfig({
          status,
          loaded,
          payload,
          data
        });
      }).catch(console.error);
    }
  }, []);
  return {
    config
  };
};
export {
  useApplicationBootHook
};
